import { render, staticRenderFns } from "./ContentApproval.vue?vue&type=template&id=3bdd07ee&"
import script from "./ContentApproval.vue?vue&type=script&lang=js&"
export * from "./ContentApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports